/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerFindOneQueryResponse,
  UserFlagsModeratorControllerFindOnePathParams,
  UserFlagsModeratorControllerFindOne401,
} from '../../types/UserFlagsModeratorControllerFindOne.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { userFlagsModeratorFindOne } from '../../methods/userFlagsModeratorFindOne.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const userFlagsModeratorFindOneQueryKey = (id: UserFlagsModeratorControllerFindOnePathParams['id']) =>
  [{ url: '/api/moderator/user-flags/:id', params: { id: id } }] as const;

export type UserFlagsModeratorFindOneQueryKey = ReturnType<typeof userFlagsModeratorFindOneQueryKey>;

export function userFlagsModeratorFindOneQueryOptions(
  id: UserFlagsModeratorControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = userFlagsModeratorFindOneQueryKey(id);
  return queryOptions<
    UserFlagsModeratorControllerFindOneQueryResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerFindOne401>,
    UserFlagsModeratorControllerFindOneQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return userFlagsModeratorFindOne(id, config);
    },
  });
}

/**
 * {@link /api/moderator/user-flags/:id}
 */
export function useUserFlagsModeratorFindOne<
  TData = UserFlagsModeratorControllerFindOneQueryResponse,
  TQueryData = UserFlagsModeratorControllerFindOneQueryResponse,
  TQueryKey extends QueryKey = UserFlagsModeratorFindOneQueryKey,
>(
  id: UserFlagsModeratorControllerFindOnePathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        UserFlagsModeratorControllerFindOneQueryResponse,
        ResponseErrorConfig<UserFlagsModeratorControllerFindOne401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userFlagsModeratorFindOneQueryKey(id);

  const query = useQuery(
    {
      ...userFlagsModeratorFindOneQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<UserFlagsModeratorControllerFindOne401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
